import { render, staticRenderFns } from "./AddDocument.vue?vue&type=template&id=4f5d5832&"
import script from "./AddDocument.vue?vue&type=script&lang=js&"
export * from "./AddDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports